import router from "../router";

const state = {
	buildings: [],
	buildingRooms: [],
	selectedBuilding: null,
	selectedRoom: null
};

const mutations = {
	setBuildings(state, payload) {
		state.buildings = payload;
	},

	setBuildingRooms(state, payload) {
		state.buildingRooms = payload;
	},

	setSelectedRoom(state, payload) {
		state.selectedRoom = payload;
		//if (payload) { router.push({ name: "highlightRoom", params: { bldg: payload.bldgAlpha, room: payload.number } }) }		
	},

	setSelectedBuilding(state, payload) {
		state.selectedBuilding = payload
	},

	resetState() {
		state.buildingRooms = []
		state.selectedRoom = null;
		state.selectedBuilding = null;
	},

};

const getters = {
/*  	getRoom : (state) => (roomNumber) => { 
   	 	return state.buildingRooms.find(room => room.number == roomNumber)
  	},*/

  	getBuilding : (state) => (bldgAlpha) => {
		return state.buildings.find(bldg => bldg.bldgAlpha == bldgAlpha)
	},

};

const actions = {

/*	setSelectedBuilding({commit, dispatch, state}, payload) {		
		return new Promise((resolve, reject) => {
			commit('resetState')
			if (payload) {
				//router.push({ name: "highlightBuilding", params: { bldg: payload.bldgAlpha } });	
				dispatch('fetchBuildingRooms', payload.bldgAlpha).then((data) => { resolve(data) })
				state.selectedBuilding = payload
			}
		})
	},*/

	// List of building table and supporting properties
	fetchBuildings({ commit, getters }) {
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if_core/api/buildings/simple", {
				headers: { "content-type": "application/json" }
			})
			.then(response => response.json())
			.then(data => {
				commit("setBuildings", data); // Commit mutation above
				resolve(data);
			});
		});
	},

	// Fetch one building
	fetchBuilding({ commit, getters }, payload) {
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if_core/api/building/" + payload, {
				headers: { "content-type": "application/json" }
			})
			.then(response => response.json())
			.then(data => {
				commit("setSelectedBuilding", data); // Commit mutation above
				resolve(data);
			});
		});
	},

	// All rooms for one building.  Shallow return
	fetchBuildingRooms({ rootState, commit, getters }, bldgAlpha) {
		return new Promise((resolve, reject) => {
			commit('setBuildingRooms', [])
			//console.log("Action: fetchBuildingRooms " + bldgAlpha);
			fetch("https://api.ba.arizona.edu/if_core/api/rooms/" + bldgAlpha, {
				headers: { "content-type": "application/json" }
			})
			.then(response => response.json())
			.then(data => {
				commit("setBuildingRooms", data);
				resolve(data);
			});
		});
	},

	getFloorByFacID ({rootState, dispatch }, payload) { //300A-A306
		if (payload) {
			//console.log("Action: getFloorByRoomKey ")
			//Break into bldg, room
            let facID = payload.split("-")
            let bldgAlpha = facID[0]
            let number = facID[1]

			return new Promise((resolve, reject) => {
				fetch('https://api.ba.arizona.edu/if_core/api/room/' + bldgAlpha + '/' + number, {
						headers: { "content-type": "application/json" }
		  			})
			      .then(response => response.json())
			      .then(data => {
			      	dispatch('updateLayerVisibility', data.floor).then(() => {
			      		resolve(data.floor)
			      	})			        
			      })
			  })
		} 
	},

	getRoomByFacIDV2 ({commit, getters}, payload) {
		console.log("Action: getFloorByFacIDV2 ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if_core/api/room/facIdNum', 
			 {
                        headers: {
                        'Content-Type': 'application/json',
                        },
                        method: "POST",
                        body: JSON.stringify(payload)
                })
		      .then(response => response.json())
		      .then(data => {
		        console.log(data)
		        resolve(data)
		      })
		  })
	},

};

export default {
	state,
	actions,
	mutations,
	getters
};